<template>
<Transition>
<div data-cy="card" class="card" :class="['style-' + categoryStyle]" 
                                          v-if="activeMarkerId">

  <!--<svg @click="closeCard()" class="close-icon" width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.1094 10.6406C13.6172 11.1094 13.6172 11.9297 13.1094 12.3984C12.875 12.6328 12.5625 12.75 12.25 12.75C11.8984 12.75 11.5859 12.6328 11.3516 12.3984L7.25 8.29688L3.10938 12.3984C2.875 12.6328 2.5625 12.75 2.25 12.75C1.89844 12.75 1.58594 12.6328 1.35156 12.3984C0.84375 11.9297 0.84375 11.1094 1.35156 10.6406L5.45312 6.5L1.35156 2.39844C0.84375 1.92969 0.84375 1.10938 1.35156 0.640625C1.82031 0.132812 2.64062 0.132812 3.10938 0.640625L7.25 4.74219L11.3516 0.640625C11.8203 0.132812 12.6406 0.132812 13.1094 0.640625C13.6172 1.10938 13.6172 1.92969 13.1094 2.39844L9.00781 6.53906L13.1094 10.6406Z" fill="white"/>
  </svg>-->
  <div class="multimedia-slider">
        <div class="swiper multimedia" v-if="showSwiperNav || toggleModel">
        <Swiper ref="swiper" v-if="showSwiperNav"
                :modules="[Pagination]"
              :pagination="{
        el: '.swiper-pagination-custom',
        type: 'bullets',
        clickable: true
      }">
        <SwiperSlide v-for="(slide, index) in activeMarkerData.images" :key="index"><div class="background-image" :style="{ 'background-image': 'url(' + slide + ')' }"></div></SwiperSlide>
        </Swiper>          

          <div class="pagination-container" v-show="showSwiperNav">
            <div class="swiper-pagination-custom"></div>
          </div>
        </div>

        <div v-if="false && !activeMarkerData.images" class="background-image-placeholder" :style="{ 'background-image': 'url(' + returnPlaceholder(categoryStyle) + ')' }"></div>
      </div>
      <div class="content">
          <div v-if="activeMarkerData.type != 'event'" class="title">
            <img  @click="closeCard()" class="exit-arrow" :src="exitArrow" alt="">
            {{   t(useItineraryStore().activePoiProperties.id+".title")}}
          </div>
        <div class="categories">
          <img v-if="activeMarkerData.type == 'event'" class="event-category" :src="timeIcon" alt="">
          <template v-for="(icon, index)  in activeMarkerData.categoryIcon">
            <img v-if="index != 0" :class="'style-' + icon.categoryId" :src="icon.img" alt="" />
          </template>
          <a target="_blank" class="navigation-to-poi-btn" :href="navGoogleMapsLink()">
            <img :src="navIcon" alt="">
            <span>Navigate</span>
          </a>
        </div>
        <div class="description" v-html="formattedDescription">
        </div>
        <div class="info-container">
          <p v-if="activeMarkerData.address">{{ t('general.address') }}: {{ activeMarkerData.address }}</p>
          <p v-if="activeMarkerData.openingHours">{{ t('general.opening_hours') }}: {{ activeMarkerData.openingHours }}</p>
          <p v-if="activeMarkerData.international_phone_number">{{ t('general.phone') }}: {{ activeMarkerData.international_phone_number }}</p>
          <p v-if="activeMarkerData.email">{{ t('general.email') }}: {{ activeMarkerData.email }}</p>
          <p v-if="activeMarkerData.website">{{ t('general.website')  }}: {{ activeMarkerData.website }}</p>
        </div>
      </div>
</div>
</Transition>
</template>
<script setup>
import {ref, watch,nextTick, computed,onUpdated, onMounted,onUnmounted} from "vue";
import { useItineraryStore } from '@/stores/itinerary-stores.ts'
import { quillDeltaToHtml, quillDeltaToPlainText } from '@/utils/quill-parser';
//swiper
import { Swiper, SwiperSlide } from 'swiper/vue';
import 'swiper/swiper-bundle.css';
import {createGoogleMapsLink} from '@/utils/helpers.js'; 
import { Pagination, Navigation, Autoplay } from 'swiper/modules';
import missingImageCulture from '@/assets/card/image-missing-culture.svg'
import missingImageNature from '@/assets/card/image-missing-nature.svg'
import missingImageTourism from '@/assets/card/image-missing-tourism.svg'
import missingImageSport from '@/assets/card/image-missing-sport.svg'
import missingImageEvent from '@/assets/card/image-missing-event.svg'
import navIcon from "@/assets/navigation-icon.svg";
import exitArrow from '@/assets/right-arrow.svg';
//drejc
import { useI18n } from "vue-i18n";
//import { start } from "repl";
//import '@google/model-viewer';

//drejc
const { t } = useI18n();

const translatedCard = ref(null);
const activeMarkerId = ref(null);
const marker = ref(null);
const categoryStyle = ref();
const swiper = ref(null);
const activeEvents = ref([]);
const swiperEvent = ref(null);
const activeMarkerData = ref({
  address: "",
  locationData: "",
  openingHours: "",
  contactInformation: "",
  categoryIcon: [],
  images: [],
  openingHours: "",
  email: "",
  videos:[],
  international_phone_number: "",
  website: "",
  type: "",
});
const isModel = ref(false);
const selectedMarkerColor = ref();
const singleEventData = ref();
const showSwiperNav = ref(true);
const coordinates = ref(null);

const formattedDescription = computed(() => {
  try {
    const description = t(useItineraryStore().activePoiProperties.id + ".description");
    if (!description) return '';
    
    // If the description is already a string (not JSON), return it as is
    if (typeof description === 'string' && !description.startsWith('{')) {
      return description;
    }
    
    // Parse the Quill Delta JSON
    const quillJson = JSON.parse(description);
    const html = quillDeltaToHtml(quillJson);
    
    // Escape any Vue template syntax in the HTML
    return html
      .replace(/{{/g, '&#123;&#123;')
      .replace(/}}/g, '&#125;&#125;')
      .replace(/\n/g, '<br>')
      .replace(/\r/g, '');
  } catch (error) {
    console.error('Error parsing Quill Delta:', error);
    // If parsing fails, return the original description with escaped template syntax
    const fallbackText = t(useItineraryStore().activePoiProperties.id + ".description") || '';
    return fallbackText
      .replace(/{{/g, '&#123;&#123;')
      .replace(/}}/g, '&#125;&#125;')
      .replace(/\n/g, '<br>')
      .replace(/\r/g, '');
  }
});

const setPresentationData = (newValue) => {
  let markerDataTemp = null;

  let destinationId = useItineraryStore().activeDestination;
  console.log('useItineraryStore().itinerary[useItineraryStore().selectedPath]',useItineraryStore().itinerary[useItineraryStore().selectedPath])
  if(useItineraryStore().selectedPath != null) {
    if(useItineraryStore().itinerary[useItineraryStore().selectedPath].pois != undefined) {
      let data = useItineraryStore().itinerary[useItineraryStore().selectedPath].pois.filter((poi) => {
        if(poi.properties.id == newValue) {
          return true;
        }
      })
    
      //destinationId = useItineraryStore().activeDestination;
      markerDataTemp = data[0];
    }
  }
  if(markerDataTemp == null) {
    markerDataTemp = useItineraryStore().markers[newValue];
    destinationId = useItineraryStore().closestDestinationId;
  }

  //console.log(" markerDataTemp.geometry.coordinates: ", markerDataTemp.geometry.coordinates);
  coordinates.value = markerDataTemp.geometry.coordinates;
  const {
    id,
    address,
    locationData,
    openingHours,
    contactInformation,
    email,
    international_phone_number,
    website,
    categories,
    type,
  } = markerDataTemp.properties;

  console.log('markerDataTemp',markerDataTemp)
  selectedMarkerColor.value = useItineraryStore().returnStartStopColor(categories[0]);
  activeMarkerId.value = id;
  categoryStyle.value = categories[0];
  activeMarkerData.value = {
    address,
    locationData,
    openingHours,
    contactInformation,
    email,
    international_phone_number,
    website,
    //images: ['https://miza.simpl.guide/repo/10/c1d2b5c669420ebd198a6bc7d23bf791-m.jpg'],

    images: getPoiImages('m',markerDataTemp.properties,destinationId),
    videos: useItineraryStore().getMarkerVideos(markerDataTemp,destinationId),
    categoryIcon: categories.map((id) => ({
      img: useItineraryStore().returnCategoryIcon(id),
      categoryId: id,
    })),
    type,
  };

  console.log("activeMarkerData", activeMarkerData.value);

  try {
    isModel.value = mapStoreData.markers[newValue].properties.presentation.basic.content.hasOwnProperty("model");

    if(isModel) {
      let files = mapStoreData.markers[newValue].properties.presentation.basic.content.model.files[0];
      modelUrl.value = 'repo/' + useItineraryStore()().closestDestinationId + '/' + files.hash + "." + files.ext;
    }
  } catch (error) {
    isModel.value = false;
  }

  markerDataTemp.properties.type === 'event' ? singleEventData.value = mapStoreData.markers[newValue] : singleEventData.value = null;
  const isSingleImage = activeMarkerData.value.images.length > 0 || activeMarkerData.value.videos.length > 0;
  
  //debugger;
  activeEvents.value = [];
  if(markerDataTemp.properties.hasOwnProperty('events')) {
    assignEvents(markerDataTemp.properties.events);
  }
};



function getPoiImages(size, data,destinationIdKurac){
            const destinationId = useItineraryStore().currentDestination;
            const publicUrl = import.meta.env.VITE_MIZA_REPO_URL;
            let presentation = null;
            console.log('getPoiImages', data);
            if (data.presentation === null) {
              return false;
            }
            /*
            try{
              presentation = JSON.parse(data.properties.presentation)
            }catch{
              return false;
            }
            */
            presentation = data.presentation;
          
            if (presentation.basic==undefined || presentation.basic.content==undefined 
                || presentation.basic.content.gallery==undefined || presentation.basic.content.gallery.files==undefined 
                 || !Array.isArray(presentation.basic.content.gallery.files)  || presentation.basic.content.gallery.files.length == 0) {
              return false;
            }
          
          
            // Create image URLs
            
            let images = [];
            presentation.basic.content.gallery.files.forEach((slide, i)=> {
              images.push(`${publicUrl}${destinationId}/${slide.hash}-${size}.${slide.ext}`)
            })

        
            return images;
}


function navGoogleMapsLink() {
  /*if(useItineraryStore().currentLocationCoordinates == null) return;
  const [startLng, startLat] = useItineraryStore().currentLocationCoordinates;*/
  const [endLng, endLat] = coordinates.value;
  const baseUrl = 'https://www.google.com/maps/dir/?api=1';
  const destinationParam = `destination=${endLat},${endLng}`;
  const travelModeParam = 'travelmode=driving';

  return `${baseUrl}&${destinationParam}&${travelModeParam}`;
}
watch(
  () => useItineraryStore().activePoi,
  (newValue) => {
    if(newValue !== null) {
      setPresentationData(newValue)
    }else {
      console.log("new value is null")
      closeCard();
    }
  }
)

// drejc too ne dela, umikam
const returnPlaceholder = (category) => {
  let image = null;
  //debugger;
  if(useItineraryStore().activePoi === null) return;

  if(useItineraryStore().markers[useItineraryStore().activePoi].hasOwnProperty('properties')) {
    if(useItineraryStore().markers[useItineraryStore().activePoi].properties.type == 'event') {
      image = missingImageEvent;
      return image;
    }
  }
  switch (category) {
      case 80:
        image = missingImageNature;
        break;
      case 81:
        image = missingImageSport;
        break;
      case 82:
        image = missingImageCulture;
        break;
      case 83:
        image = missingImageTourism;
        break;
      default:
        image = missingImageCulture;
        break;
    }

    return image;
}

const closeCard = () => {
  useItineraryStore().activePoi = null;	
};


</script>
<style scoped lang="scss">
@import '@/assets/styles/mixins.scss';
.mapboxgl-popup-content {
    background-color: transparent !important;
    border-radius: 3px;
    box-shadow: none !important;
    padding: 0 !important;
    pointer-events: auto;
    position: relative;
} 

.card {
    width:get-vw(335px);
    background-color: #fff;
    border-radius: get-vw(20px);
    color:#000;
    //overflow-y: auto;
    .exit-arrow {
      transform: rotate(180deg);
    }
    &.event {
        .model-icon-container {
            &.active {
                background-color:#D6779D !important;
            }
        }
    }
    .event-info {
        display: flex;
        background: linear-gradient(180deg, #D6779D 0%, #BD567B 100%);
        color:#fff;
        margin-bottom:get-vw(15px);
        padding:get-vw(15px);
        display: flex;
        background: linear-gradient(180deg, #D6779D 0%, #BD567B 100%); 
        .timeIcon {
            width:get-vw(40px);
            margin-right:get-vw(25px);
        }
        .info {
            width:70%;
            .event-title {
                font-size: get-vw(20px);
                margin-bottom: get-vw(5px);
                font-weight: 700;
            }
            .event-date {
                font-size: get-vw(15px);
                line-height: get-vw(20px);
            }
        }
    }
    &.favorited {
        .disableIfNotActive {
            opacity: 1 !important;
            pointer-events: all !important;
        }
    }
    .close-icon {
        width:get-vw(20px);
        height:get-vw(20px);
        position:absolute;
        z-index: 9;
        top:get-vw(20px);
        right:get-vw(20px);
    }
    b{
        font-weight: 700;
    }
    p {
        font-size: get-vw(15px);
        font-weight: 500;
        line-height: normal;
        margin: 0;
    }
    .favorite-flags {
        width:get-vw(40px);
        height:get-vw(40px);
        border-radius: 50%;
    }
    .title {
        font-size: get-vw(20px);
        font-weight: 700;
        margin:get-vw(15px) 0;
        line-height: normal;
      }
      .content {
        padding: 0 get-vw(50px) get-vw(10px) get-vw(10px);
      }
      .description {
        font-size: get-vw(15px);
        line-height: normal;
        //max-height:get-vw(100px);
        overflow-y:auto;
        padding: get-vw(10px) get-vw(10px) get-vw(0px) get-vw(0px);
        &::-webkit-scrollbar {
            width: 5px;
            height: 5px;
            background:-webkit-linear-gradient(0, blue 50%, white 100%);
          }
    
          &::-webkit-scrollbar-track {
            border-radius: get-vw(5px);
            background-color: #F5F5F5;
          }
    
          &::-webkit-scrollbar {
            width: get-vw(5px);
            background-color: #F5F5F5;
          }
    
          &::-webkit-scrollbar-thumb {
            border-radius: get-vw(5px);
            background-color: var(--culture-color-start);
          }
      }
      .categories {
        position: relative;
        margin-bottom: get-vw(15px);
        margin-top: get-vw(15px);
        display: flex;
        img {
          padding:get-vw(5px);
          width:get-vw(30px);
          height:get-vw(30px);
        }
      }
      .multimedia-slider {
        //border-bottom-width: get-vw(8px) solid;
        &.event {
            .background-image-placeholder {
                background-color:#D6779D;
                background-size: 20%;
            }
        }
        video {
            position:absolute;
            width: 100%;
        }
        .modelviewer {
            height:get-vw(285px);
        }
      }
    &.style-80 {
        .multimedia-slider {
            //border-bottom: get-vw(8px) solid var(--nature-color-start);
            //border-radius: get-vw(20px);
        }
        .description {
              &::-webkit-scrollbar-thumb {
                border-radius: get-vw(5px);
                background-color: var(--nature-color-start);
              }
          }
        &.favorited {
            .favorite-flags {
                background-color: var(--nature-color-start);
                path {
                    fill:#fff
                }
                rect {
                    fill:var(--nature-color-start);
                
                }
            }

            &.event {
                .favorite-flags {
                    background-color:#D6779D;
                    path {
                        fill:#fff
                    }
                    rect {
                        fill:#D6779D;
                    
                    }
                }
            }
        }
        .background-image-placeholder {
            background-color: var(--nature-color-start);
        }
        .model-icon-container.active {

            background-color: var(--nature-color-start);
        }
    }
    &.style-81 {
        .multimedia-slider {
            //border-bottom: get-vw(8px) solid var(--sport-color-start);
        }
        .background-image-placeholder {
            background-color: var(--sport-color-start);
        }
        .description {
            &::-webkit-scrollbar-thumb {
              border-radius: get-vw(5px);
              background-color: var(--sport-color-start);
            }
        }
        &.favorited {
            .favorite-flags {
                background-color: var(--sport-color-start);
                path {
                    fill:#fff
                }
                rect {
                    fill:var(--sport-color-start);
                
                }
            }
        }
        .model-icon-container.active {
            background-color: var(--sport-color-start);
        }
    }
    &.style-82 {
        .multimedia-slider {
           // border-bottom: get-vw(8px) solid var(--culture-color-start);
        }
        .background-image-placeholder {
            background-color: var(--culture-color-start);
        }
        .description {
            &::-webkit-scrollbar-thumb {
              border-radius: get-vw(5px);
              background-color: var(--culture-color-start);
            }
        }
        &.favorited {
            .favorite-flags {
                background-color: var(--culture-color-start);
                path {
                    fill:#fff
                }
                rect {
                    fill:var(--culture-color-start);
                
                }
            }
        }
        .model-icon-container.active {
            background-color: var(--culture-color-start);
        }
    }
    &.style-83 {
        .multimedia-slider {
            //border-bottom: get-vw(8px) solid var(--turism-color-start);
        }
        .background-image-placeholder {
            background-color: var(--turism-color-start);
        }
        .description {
            &::-webkit-scrollbar-thumb {
              border-radius: get-vw(5px);
              background-color: var(--turism-color-start);
            }
        }
        &.favorited {
            .favorite-flags {
                background-color: var(--turism-color-start);
                path {
                    fill:#fff
                }
                rect {
                    fill:var(--turism-color-start);
                
                }
            }
        }
        .model-icon-container.active {
            background-color: var(--turism-color-start);
        }
    }
    .multimedia-slider {
        width:100%;
        max-height: 50vh;
        height:100%;
        overflow: hidden;
        //border-radius: get-vw(20px) get-vw(20px) get-vw(0px) get-vw(0px);
        position: relative;

        &.event {
            border:0;
        }
        .swiper-slide {
            width:100%;
            height:100%;
            .background-image {
                width:100%;
                height: 50vh;
                background-size:cover;
                background-position:center;
            }
        }
        .background-image-placeholder {
            width:100%;
            height: 50vh;
            background-size:20%;
            background-position:center;
        }
    }

    .options {
        display: flex;
        justify-content: flex-end;
        align-items: center;

        .model-icon-container {
            width: get-vw(41px);
            height: get-vw(41px);
            margin-right: get-vw(5px);
            position: relative;
            border-radius: 50%;
            
            svg {
                position: absolute;
                top:50%;
                left:50%;
                transform: translate(-50%,-50%);
            }
        }
    }
    .info-container {
        margin:get-vw(25px) 0;
        font-style: italic;
    }
    .disableIfNotActive {
        opacity: 0.1;
        pointer-events: none;
    }   
    .pagination-container {
      z-index: 99;
      width: 100%;
      position: absolute;
      bottom:0;
    }
}

@media only screen and (orientation: portrait) {
    .card {
        position: absolute;
        width: 100vw;
        right:0;
        bottom:0;
        border-radius: get-vw(20px,1080);
        height: calc(100% - 70px);
        z-index: 4;
        overflow: hidden;
        p {
            font-size: get-vw(35px,1080);
        }
        .favorite-flags {
            width:get-vw(40px,1080);
            height:get-vw(40px,1080);
        }
        .model-icon-container.active {
            width:get-vw(41px,1080);
            height:get-vw(41px,1080);
        }
        .title {
            font-size: get-vw(75px,1080);
            margin:get-vw(18px,1080) 0;
          }
          .description {
            font-size: get-vw(40px,1080);
            max-height: 20vh;
            padding: get-vw(10px,1080) get-vw(30px,1080) get-vw(0px,1080) get-vw(0px,1080);
            p {
              margin: 0;
            }
            &::-webkit-scrollbar {
                width: get-vw(12px,1080);
                height: get-vw(12px,1080);
              }
        
              &::-webkit-scrollbar-track {
                border-radius: get-vw(12px,1080);
              }
        
              &::-webkit-scrollbar {
                width: get-vw(12px,1080);
              }
        
              &::-webkit-scrollbar-thumb {
                border-radius: get-vw(12px,1080);
              }
          }
          .close-icon {
            width:get-vw(50px,1080);
            height:get-vw(50px,1080);
            top:get-vw(50px,1080);
            right:get-vw(50px,1080);
          }
        .multimedia-slider {
            //border-bottom-width: get-vw(8px,1080) !important;
            max-height: 41vh;         
            //border-top-left-radius:get-vw(20px,1080);
            //border-top-right-radius:get-vw(20px,1080);
            border-bottom-left-radius: 0;
            border-bottom-right-radius: 0;
            .swiper-slide {
                .background-image {
                    height: 40vh;
                    border-radius: 0px 0px get-vw(60px) get-vw(60px);
                }
            }
            .background-image-placeholder {
                height: 40vh;
            }
        }
    }
}

.navigation-to-poi-btn {
        display: flex;
        width:max(get-vw(129px),129px);
        height: max(get-vw(30px),30px);
        position: absolute;
        background-color: #2E3D45;
        top:0;
        right:0;
        z-index: 1000;
        justify-items: center;
        align-items: center;
        justify-content: space-between;
        color:#fff;
        font-weight: 400;
        border-radius: 50px;
        padding: 0 get-vw(30px) 0 get-vw(10px);
        font-size: max(get-vw(16px),13px);
        text-decoration: none;
}

@media (max-width: 484px) {
  .navigation-to-poi-btn { 
    right: 10px;
  }
  .card .content{
    padding-right: 15.5vw;
  }
}

@media only screen and (orientation: landscape) {
  .card {
    position: absolute;
        width: 100vw;
        right: 0;
        bottom: 0;
        border-radius: 1.8518518519vw;
        height: calc(100% - 70px);
        z-index: 4;
        display: flex;
        flex-direction: row-reverse;
        .content {
          width:100%;
          max-width: 50%;
        }
        .close-icon {
          top:get-vw(10px);
          right:get-vw(10px);
          width: get-vw(10px);
          height: get-vw(10px);
        }
        .multimedia-slider {
          width:100%;
          max-width: 50%;
          height:calc(100vh - 70px);   
          max-height:calc(100vh - 70px);  
          .swiper-slide .background-image {
            max-width: 100%;
            height:auto;
            border-radius: 0;
          }
          .swiper-slide  {
            width:100%;
            border-radius: 0;
            .background-image {
              width:100%;
              height:calc(100vh - 70px);
              border-radius: 0;
            }
          }
        }
        .title {
            font-size: get-vw(12px);
            margin:get-vw(5px) 0;
        }
        .description {
          //overflow-y: visible;
          margin:0;
          font-size: get-vw(8px);
          max-height:get-vw(120px);
          overflow-y: auto;
          p{
            margin:0;
            font-size: get-vw(8px);
          }
        }
        .info-container {
          margin: get-vw(10px) 0;
          p {
            font-size: get-vw(6px);
          }
        }
        .categories  {
          img {
            width: get-vw(12px);
            height: get-vw(12px);
            padding: get-vw(2px);


            border-radius: 50%;
          }
        }
  }
  .navigation-to-poi-btn {
        display: flex;
        width:149px;
        height: 40px;
        position: absolute;
        background-color: #2E3D45;
        top:-3px;
        right:0;
        z-index: 1000;
        justify-items: center;
        align-items: center;
        justify-content: space-between;
        color:#fff;
        font-weight: 500;
        border-radius: 50px;
        padding: 0 30px 0 10px;
        font-size: 20px;
        a {
          text-decoration: none;
        }
}
}

</style>